import { GetFileExtension, getJwt, imageFormats } from "@app/helpers";
import api from "../api";
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';

const controller = 'subcontratacao';

export interface IPermissoesSubcontratacao {
  contratoId: string;
  isGestorContrato: boolean;
  isFiscalContrato: boolean;
  isPerfilAdministradorContrato: boolean;
  podeCadastrar: boolean;
  podeConfirmar: boolean;
}

export const createSubcontratacao = (subcontratacao: any) => api.post(`${controller}`, subcontratacao);
export const deleteSubcontratacao = (subcontratacaoId: string) => api.delete(`${controller}/${subcontratacaoId}`);
export const getSubcontratacoesContrato = (contratoId: string) => api.get<any[]>(`${controller}/${contratoId}`);
export const updateSubcontratacao = (subcontratacao: any) => api.put(`${controller}`, subcontratacao);
export const submeterSubcontratacao = (dados: any) => api.put(`${controller}/submeter`, dados);
export const salvarNovasSubcontratadasAutorizadas = (dados: any) => api.put(`${controller}/salvarNovasSubcontratadasAutorizadas`, dados);
export const getPermissoesSubcontratacao = (contratoId: string) => api.get<IPermissoesSubcontratacao>(`${controller}/permissoes/${contratoId}`);

export const salvarComentarioSubcontratacao = (comentario: any) => api.post<any>(`${controller}/comentario`, comentario);
export const getComentariosSubcontratacao = (subcontratacaoId: string) => api.get<any[]>(`${controller}/comentarios/${subcontratacaoId}`);

export const devolverSubcontratacao = (contratoId: string) => api.put(`${controller}/devolver/${contratoId}`);

export const uploadAnexoSubcontratacao = (anexo: any) => api.post<any>(`${controller}/anexo`, anexo);
export const downloadAnexoSubcontratacao = (subcontratacaoId: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/anexo/${subcontratacaoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        //Get filename from response header
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '').replace(/={1}/g, '%').replaceAll('+', ' ');
            filename = decodeURI(filename);
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          notification.error('Houve um erro ao exportar.');
        }
      }),
  );
}

export const viewAnexoSubcontratacao = (subcontratacaoId: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/${controller}/anexo/${subcontratacaoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        //Get filename from response header
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '').replace(/={1}/g, '%').replaceAll('+', ' ');
            filename = decodeURI(filename);
          }
        });
        if (filename !== '') {
          let file = undefined;
          let fileUrl = undefined;
          const fileExtension = GetFileExtension(filename);
          if (fileExtension === 'pdf') {
            file = new Blob([resp.data], { type: 'application/pdf' });
            fileUrl = URL.createObjectURL(file);
          } else if (imageFormats.includes(fileExtension)) {
            file = new Blob([resp.data], { type: 'image/' + fileExtension });
            fileUrl = URL.createObjectURL(file);
          }
          if (fileUrl !== undefined) var response = window.open(fileUrl);
        }
      })
      .catch(error => {
        if (error.response) {
          notification.error('Houve um erro ao exportar.');
        }
      }),
  );
}